import { useSearchParams } from "react-router-dom";

export type PanelType = "book" | "details";

export const useMessagesSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isBookingFormOpen = searchParams.get("book") === "true";
  const isDetailsOpen = searchParams.get("details") === "true";

  const openPanel = (panel: PanelType) => {
    const newParams = new URLSearchParams(searchParams);

    // Remove the other panel to make them mutually exclusive
    if (panel === "book") {
      newParams.delete("details");
      newParams.set("book", "true");
    } else {
      newParams.delete("book");
      newParams.set("details", "true");
    }

    // Use replace: true to avoid polluting history
    setSearchParams(newParams, { replace: true });
  };

  const closePanel = (panel: PanelType) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(panel);

    // Use replace: true to prevent history navigation from restoring old state
    setSearchParams(newParams, { replace: true });
  };

  const togglePanel = (panel: PanelType) => {
    const isOpen = panel === "book" ? isBookingFormOpen : isDetailsOpen;
    if (isOpen) {
      closePanel(panel);
    } else {
      openPanel(panel);
    }
  };

  return {
    isBookingFormOpen,
    isDetailsOpen,
    openPanel,
    closePanel,
    togglePanel,
  };
};
